import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentName'
})
export class DocumentNamePipe implements PipeTransform {

  transform(fileName: string): string[] {
    if (typeof fileName === 'string' && fileName.length) {
      const splitedName = fileName.split('.');

      return [...splitedName.slice(0, -1), `.${splitedName.pop()}`];
    } else {
      return [];
    }
  }

}
